export function isLeapYear(year) {
  const y = Number(year);
  return y >= 1 && y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0);
}

export function getDaysInMonth(month, year) {
  const m = Number(month);
  if (!m || m < 1 || m > 12) {
    return 31;
  }
  if (m === 2) {
    if (year === undefined || year === null || year === "") {
      return 29;
    }
    return isLeapYear(year) ? 29 : 28;
  }
  return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m - 1];
}

export function isYearOptionVisible(year, month, day) {
  if (Number(month) === 2 && String(day) === "29") {
    return isLeapYear(year);
  }
  return true;
}
